require('../../modules/es6.math.expm1');
module.exports = require('../../modules/_core').Math.expm1;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/expm1.js
// module id = 1421
// module chunks = 2